'use client';

import React from 'react';
import InputPincode from './InputPincode';
import styles from './CategorySidebar.module.css';

export interface Category {
  id: string;
  name: string;
  icon_url: string;
  description?: string;
  plan_count?: number;
  plans?: any[];
}

interface CategorySidebarProps {
  categories: Category[];
  activeCategory?: string;
  onCategoryChange?: (categoryId: string) => void;
  topOffset: number;
  mobileTopOffset: number;
  sidebarRef?: React.MutableRefObject<HTMLElement | null>;
  categoryRefs?: React.MutableRefObject<Record<string, HTMLElement | null>>;
  selectedGender?: 'male' | 'female';
  onGenderChange?: (gender: 'male' | 'female') => void;
}

const CategorySidebar: React.FC<CategorySidebarProps> = ({
  // categories,
  // activeCategory,
  // onCategoryChange,
  topOffset,
  mobileTopOffset,
  sidebarRef,
  // categoryRefs,
  selectedGender = 'male',
  onGenderChange,
}) => {
  return (
    <aside
      className={`${styles.sidebar} u-hide-scrollbar`}
      data-category-sidebar
      style={
        {
          '--top-offset': `${topOffset}px`,
          '--mobile-top-offset': `${mobileTopOffset}px`,
        } as React.CSSProperties
      }
      ref={(el) => {
        if (sidebarRef) {
          sidebarRef.current = el;
        }
      }}
    >
      {/* InputPincode only on desktop */}
      <div className={styles.desktopPincodeWrapper}>
        <InputPincode />
      </div>

      {/* Separator between InputPincode and gender selection on desktop */}
      <div className={styles.separator} />

      {/* Gender Selection - only on desktop */}
      <div className={styles.genderSelectionWrapper}>
        <h5 className={styles.genderSelectionTitle}>Select your Gender</h5>
        <div className={styles.genderOptionsContainer}>
          <button
            className={styles.genderOption}
            data-selected={selectedGender === 'male'}
            onClick={() => onGenderChange?.('male')}
            type="button"
            aria-label="Select Male"
            aria-pressed={selectedGender === 'male'}
          >
            <div
              className={styles.radioButton}
              data-selected={selectedGender === 'male'}
            />
            <span
              className={styles.genderOptionText}
              data-selected={selectedGender === 'male'}
            >
              Male
            </span>
          </button>
          <button
            className={styles.genderOption}
            data-selected={selectedGender === 'female'}
            onClick={() => onGenderChange?.('female')}
            type="button"
            aria-label="Select Female"
            aria-pressed={selectedGender === 'female'}
          >
            <div
              className={styles.radioButton}
              data-selected={selectedGender === 'female'}
            />
            <span
              className={styles.genderOptionText}
              data-selected={selectedGender === 'female'}
            >
              Female
            </span>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default CategorySidebar;
